import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const skeletonStyles = {
  bone: {
    display: 'block',
    backgroundColor: theme.colors.palette.grey200,
    borderRadius: theme.radius.sm,
    animation: 'ui-skeleton-pulse 1.4s ease-in-out infinite',
  } as CSSProperties,

  installmentList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.small,
    width: '100%',
  } as CSSProperties,

  installmentRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.small,
    padding: `${theme.spacing.tiny}px ${theme.spacing.medium}px`,
    borderBottom: `1px solid ${theme.colors.inputBorder}`,
  } as CSSProperties,

  installmentTexts: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
    flex: 1,
  } as CSSProperties,

  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  } as CSSProperties,

  spinner: {
    display: 'inline-block',
    flexShrink: 0,
    borderStyle: 'solid',
    borderRadius: '50%',
    animation: 'ui-spinner-rotate 0.8s linear infinite',
  } as CSSProperties,
};
